/*/
 * Navigation
/*/
	const siteNav = document.querySelectorAll('[site-nav-toggle]')

	if (siteNav) {
		siteNav.forEach(e => {
			const siteDocument = document.documentElement
			const siteNavElement = document.querySelector('.header--items')

			e.addEventListener('click', _ => {
				if (siteDocument.classList.contains('is--nav')) {
					siteDocument.classList.remove('is--nav')

					setTimeout(() => {
						siteNavElement.classList.remove('d-none')
					}, 300);
				} else {
					siteNavElement.classList.remove('d-none')

					setTimeout(() => {
						siteDocument.classList.add('is--nav')
					}, 100);
				}
			})
		})
	}

	document.addEventListener('keyup', _ => {
		const siteDocument = document.documentElement

		if (siteDocument.classList.contains('is--nav') && _.key === 'Escape') {
			siteDocument.classList.remove('is--nav')
		}
	})


/*
 * Header fixed
*/
	// scroll direction
	let siteLastScrollTop = 0;
	window.addEventListener('scroll', function () {
		const siteDocument = document.documentElement

		let st = window.pageYOffset || document.documentElement.scrollTop
		if (st > siteLastScrollTop) {
			siteDocument.classList.remove('is--header', 'is--nav')
		} else {
			siteDocument.classList.add('is--header')
		}
		siteLastScrollTop = st <= 0 ? 0 : st
	}, false)

	// start point
	const headerScroll = _ => {
		const siteDocument = document.documentElement
		const scrollElements = document.querySelectorAll('.header--offset')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) {
					siteDocument.classList.add('is--header-scrolled')
				} else {
					siteDocument.classList.remove('is--header-scrolled')
				}
			})
		}, {
			threshold: 0,
			rootMargin: '0px 0px 0px 0px'
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}

	window.addEventListener('load', function () {
		headerScroll()
	})
